import { gql, TypedDocumentNode } from '@apollo/client'

import { customerAddressFragment } from './CustomerAddressFragment'
import { CustomerFragment } from './CustomerFragment.generated'

export const customerFragment = gql`
  fragment CustomerFragment on Customer {
    firstname
    lastname
    email
    isSubscribed
    defaultBilling
    defaultShipping
    addresses {
      ...CustomerAddressFragment
    }
  }
  ${customerAddressFragment}
` as TypedDocumentNode<CustomerFragment, never>
